export default __webpack_public_path__ + "static/media/food8.50ba3bab.jpg";